import { Container } from '@almbrand/container';
import { Headline } from '@almbrand/headline';
import { Paragraph } from '@almbrand/paragraph';
import { RichText } from '@almbrand/richtext';
import { LoadingSpinner } from 'components/1-atoms/LoadingSpinner';
import { HttpStatusCode } from 'constantsValues';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchParty } from 'store/slices/partySlice';
import { getStatusMessage } from 'utilities/statusMessageUtils';

import styles from './PartyComponent.module.scss';

export interface PartyComponentProps {
	contentType?: string;
	contentId?: number;
	title?: string;

	statusMessages?: {
		items: Array<{
			content: {
				statusMessage: string;
				statusCode: HttpStatusCode;
			};
		}>;
	};
}

const PartyComponent: React.FC<PartyComponentProps> = ({ contentType, contentId, title, statusMessages }) => {
	const dispatch = useAppDispatch();
	const partyData = useAppSelector((state) => state.party.data);
	const status = useAppSelector((state) => state.party.status);

	useEffect(() => {
		if (status == HttpStatusCode.Idle) {
			dispatch(fetchParty());
		}
	}, [status, dispatch]);

	return (
		<Container
			desktopWidth='996'
			tabletWidth='fullWidth'
			mobileWidth='fullWidth'
			align='left'
		>
			{status == HttpStatusCode.Loading && <LoadingSpinner />}

			{status == HttpStatusCode.OK && partyData && (
				<>
					<Headline
						title={`Hej ${partyData?.first_name || ''} ${partyData?.last_name || ''}`}
						size={'sm'}
						variant={'h1'}
						fontColor='primary'
					/>
					<Paragraph
						text={`${title}`}
						fontColor='primaryDark'
						paragraphType={{
							type: 'standfirst',
							kind: 'title',
						}}
						className={styles.party_subHeadline}
					/>
				</>
			)}

			{(status == HttpStatusCode.InternalServerError || status == HttpStatusCode.NoContent) && (
				<RichText description={getStatusMessage(statusMessages, status)} />
			)}
		</Container>
	);
};

export default PartyComponent;
